// frontend/src/components/FinanceReport/Accounting/profit_allocations/requests.js
import { authFetch } from "../../../../api/api";

const BASE_URL = (process.env.REACT_APP_DJANGO_BACKEND || "").replace(/\/+$/, "");
const PROFIT_ALLOCATIONS_URL = `${BASE_URL}/api/accounting/profit-allocations/`;
const ACCOUNTS_URL = `${BASE_URL}/api/finances/accounts/`;

// ----------------------------------------------------------------------
// 1. GET — список прибыли по allocation
// ----------------------------------------------------------------------
export async function getAllProfitAllocations(allocationId) {
  const url = allocationId
    ? `${PROFIT_ALLOCATIONS_URL}?allocation=${allocationId}`
    : PROFIT_ALLOCATIONS_URL;

  const response = await authFetch(url);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

// ----------------------------------------------------------------------
// 2. GET — один по id
// ----------------------------------------------------------------------
export async function getOneProfitAllocation(id) {
  const response = await authFetch(`${PROFIT_ALLOCATIONS_URL}${id}/`);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return response.json();
}

// ----------------------------------------------------------------------
// 3. POST — создать
// ----------------------------------------------------------------------
export async function postProfitAllocation(payload) {
  const response = await authFetch(PROFIT_ALLOCATIONS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

// ----------------------------------------------------------------------
// 4. PATCH — частично обновить
// ----------------------------------------------------------------------
export async function patchProfitAllocation(id, patch) {
  const response = await authFetch(`${PROFIT_ALLOCATIONS_URL}${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

// ----------------------------------------------------------------------
// 5. DELETE — удалить
// ----------------------------------------------------------------------
export async function deleteProfitAllocation(id) {
  const response = await authFetch(`${PROFIT_ALLOCATIONS_URL}${id}/`, {
    method: "DELETE",
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return { ok: true, status: response.status };
}

// ----------------------------------------------------------------------
// 6. Документы — загрузка
// ----------------------------------------------------------------------
export async function uploadProfitAllocationDocument(profitId, file) {
  const fd = new FormData();
  fd.append("files", file);

  const response = await authFetch(
    `${PROFIT_ALLOCATIONS_URL}${profitId}/documents/`,
    { method: "POST", body: fd }
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

// ----------------------------------------------------------------------
// 7. Документы — удаление
// ----------------------------------------------------------------------
export async function deleteProfitAllocationDocument(documentId) {
  const response = await authFetch(
    `${BASE_URL}/api/accounting/profit-allocation-documents/${documentId}/`,
    { method: "DELETE" }
  );
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return { ok: true, status: response.status };
}

// ----------------------------------------------------------------------
// 8. Счета компании (для выпадающего списка)
// ----------------------------------------------------------------------
export async function getAllAccounts() {
  const response = await authFetch(ACCOUNTS_URL);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}